import setFaq from './pages/faq';
import setTabs from './pages/abas';

import setTopBar from "../components/topBar";
import aboutPage from './pages/about';
import setInputsMask from './pages/inputMask';

const Page = {
  init: function () {
    var _this = this;

    setTopBar();

    setFaq()
		setTabs();
    setInputsMask();
		

    if (window.location.href.includes("sobre") || window.location.href.includes("about")) {
      aboutPage.init();
    }

  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init()
})
